import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { toast } from "react-toastify";

import Card from "../../../components/Card";
import Loader from "../../../components/partials/components/loader";
import { getApiCall } from "../../../service/httpCall";
import { API_NOTIFICATION_ASSIGNED_TO_AGENT } from "../../../service/url";
import { USER_ROLES } from "../../../utilities/constant";
import { getUser } from "../../../utilities/setting";

const NotificationAssignments = () => {
  const [loading, setLoading] = useState(false);
  const [isAllowed, setIsAllowed] = useState(true);
  const [assignments, setAssignments] = useState([]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const user = getUser();
        const allowed =
          user?.role === USER_ROLES.SUPERADMIN ||
          user?.role === USER_ROLES.SUB_SUPERADMIN;
        setIsAllowed(Boolean(allowed));
      } catch (e) {
        toast.error(e || "Failed to load data");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const fetchAssignments = async () => {
    try {
      setLoading(true);
      const query = {};

      const resp = await getApiCall(API_NOTIFICATION_ASSIGNED_TO_AGENT, query);
      setAssignments(Array.isArray(resp) ? resp : []);
    } catch (e) {
      toast.error(e || "Failed to load assignments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isAllowed) return;
    fetchAssignments();
  }, [isAllowed]);

  if (loading) return <Loader />;

  return (
    <Row>
      <Col sm="12">
        <Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">
              Assiged Notifications
            </h4>
            <div className="d-flex gap-2">
              <Button
                variant="outline-primary"
                onClick={fetchAssignments}
                disabled={loading || !isAllowed}
              >
                Refresh
              </Button>
            </div>
          </Card.Header>
          <Card.Body>
            {!isAllowed ? (
              <div className="text-danger">
                Only Super Admin / Sub Superadmin can view assignments.
              </div>
            ) : (
              <>
                <h5 className="mb-2">Assigned Notifications</h5>
                <DataTable value={assignments} paginator rows={10}>
                  <Column
                    header="Notification"
                    body={(rd) =>
                      rd?.notification?.notification_type ||
                      rd?.notification_type ||
                      rd?.notification_id ||
                      "-"
                    }
                  />
                  <Column
                    header="Agent"
                    body={(rd) =>
                      rd?.agent?.agent_name ||
                      rd?.agent?.username ||
                      rd?.agent_id ||
                      "-"
                    }
                  />
                  <Column
                    header="Assigned At"
                    body={(rd) =>
                      rd?.created_at
                        ? new Date(rd.created_at).toLocaleString("en-IN")
                        : "-"
                    }
                  />
                </DataTable>
              </>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default NotificationAssignments;
